<script lang="ts" setup>
import { computed } from 'vue';
import ProjectNotes from '../ProjectNotes.vue';
import Skeleton from './ProjectNotesSkeleton.vue';
import { useProjectNotesDataMutation } from './useProjectNotesDataMutation';
import { useProjectNotesDataQuery } from './useProjectNotesDataQuery';
const props = defineProps<{
  projectId: string;
  mode?: 'read-only' | 'edit';
}>();

const { data, isLoading } = useProjectNotesDataQuery(props.projectId);
const { mutate } = useProjectNotesDataMutation(props.projectId);

const isFirstLoad = computed(() => isLoading.value);

const projectNotesProps = computed(() => ({
  initialNotes: data.value?.notes,
  mode: props.mode,
}));

function onSave(notes: string) {
  mutate(notes);
}
</script>

<template>
  <Skeleton v-if="isFirstLoad" />
  <ProjectNotes v-else v-bind="projectNotesProps" @save="onSave" />
</template>
